import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { APIService } from '../fleet-management/backend-service/backend-service';
import { LoadingService } from '../services/loading.service';
import { GlobalVariablesService } from '../global.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    RouterModule,
    MatProgressSpinnerModule,
    MatIconModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnDestroy {
  loginForm: FormGroup;
  token = '';
  isLoading: boolean = false;
  private loadingSubscription: Subscription;
  showPassword: boolean = false;
  rememberMe: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private apiService: APIService,
    public loadingService: LoadingService,
    private globalVariable: GlobalVariablesService
  ) {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
    this.loadingSubscription = this.loadingService.isLoading$.subscribe(
      loading => this.isLoading = loading
    );
  }

  ngOnDestroy() {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    // Redirect to home if already have a valid session
    const loginData = localStorage.getItem('loginData');
    const loginExpiry = localStorage.getItem('loginExpiry');
    if (loginData && loginExpiry && Date.now() < parseInt(loginExpiry, 10)) {
      this.router.navigate(['/home']);
      return;
    }

    // Check for remembered credentials
    const rememberedUser = localStorage.getItem('rememberedUser');
    if (rememberedUser) {
      this.loginForm.patchValue({ username: rememberedUser });
      this.rememberMe = true;
    }
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  getRolesOptions() {
    this.apiService.get('/api/roles/options', this.token).subscribe({
      next: (response) => {
        console.log('/api/roles/options' + ',\n' + 'Roles_Response:', response.body);
        if (response.status === 200 && response.body?.data) {
          this.globalVariable.SETTING_USER_ROLES = response.body.data;
        }
      },
      error: (error) => {
        console.error('Error fetching roles:', error.message);
      }
    });
  }

  getUserProfile() {
    this.apiService.get('/api/auth/profile', this.token).subscribe({
      next: (response) => {
        console.log('Status:', response.status);
        console.log('/api/auth/profile' + ',\n' + 'Profile_Response:', response.body);
        if (response.status === 200) {
          localStorage.setItem('userProfile', JSON.stringify(response.body))
          this.getRolesOptions();
          this.router.navigate(['/home'], { state: { username: `${response.body["lastName"]} ${response.body["firstName"]}` } });
        }
        else {
          console.log("Hey you")
        }
      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
      }
    });
  }

  onSubmit() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }
    const formData = this.loginForm.value;

    // Handle remember me
    if (this.rememberMe) {
      localStorage.setItem('rememberedUser', formData.username);
    } else {
      localStorage.removeItem('rememberedUser');
    }

    const bodyData = JSON.stringify({
      "email": "admin@example.com",
      "password": "admin123"
    });
    // const bodyData = JSON.stringify({
    //   "email": formData.username,
    //   "password": formData.password
    // });
    console.log("Login data: ", bodyData)

    this.apiService.post('/api/auth/login', bodyData, '').subscribe({
      next: (response) => {
        if (response.status === 200) {
          console.log('Login successful:', response.body.token);
          this.token = response.body.token
          localStorage.removeItem('loginData')
          localStorage.setItem('loginData', JSON.stringify(response.body))
          const expiryTime = Date.now() + 2 * 60 * 60 * 1000; // 2 hours from now
          localStorage.setItem('loginExpiry', expiryTime.toString())
          this.getUserProfile();
        }
        else {
          console.log("Hey you")
        }
      },
      error: (error) => {
        console.error('Login failed:', error.message);
      }
    });
  }
}
